var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CreativeTests',{attrs:{"discovery":"","brand":_vm.brand},on:{"openTutorialModal":function($event){return _vm.$emit('openTutorialModal')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }